import styles from "./viewTreatment.module.scss";
import React, { useMemo } from "react";

const ViewTreatmentForm = ({ viewData, editData, dressing }) => {
  const groupedViewData = useMemo(() => {
    if (!Array.isArray(viewData)) return {};

    return viewData.reduce((acc, item) => {
      if (!acc[item.key]) {
        acc[item.key] = [];
      }
      acc[item.key].push(item);
      return acc;
    }, {});
  }, [viewData]);

  return (
    <>
      {viewData?.length === 0 && "No Data Found"}

      {Object.entries(groupedViewData).map(([key, items]) => {
        const getLabel = Array.isArray(editData) && editData.find((f) => f.key === key);

        if (!getLabel) return null;

        return (
          <div key={key} className={`col-11 ${styles.col_spec} d-flex mb-3`}>
            <label className="col-5 p-0">{getLabel?.name}:</label>
            <div className="col-6 p-0">
              {items.map((item, idx) => {
                if (item?.key === "-1") {
                  return (
                    <div key={idx} className="mb-2">
                      <div className={styles.cat}>{item?.value}</div>
                    </div>
                  );
                }
                const getOption = getLabel?.options?.find((o) => o.materialNumber === item.value);
                if (!getOption) return null;
                return (
                  <div key={idx} className="mb-2">
                    <div className={styles.cat}>{getOption?.productFamilyDesc}</div>
                    <div>{getOption?.materialDescription}</div>
                    {dressing !== "secondary" && getOption?.isRecommended === 1 && <div className={styles.recommended}>Recommended</div>}
                    <div className={styles.material_code}>{getOption?.materialCode}</div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ViewTreatmentForm;
